export default __webpack_public_path__ + "static/media/commercial2.2a3a5a3e.PNG";